const env = {
  dev: {
    FIREBASE_API_KEY: 'AIzaSyBTbP-0OsF8g8UOW4cjChAKV6whnVGHn6U',
    FIREBASE_AUTH_DOMAIN: 'timetracker-manager-dev.firebaseapp.com',
    FIREBASE_DATABASE_URL: 'https://timetracker-manager-dev.firebaseio.com',
    FIREBASE_PROJECT_ID: 'timetracker-manager-dev',
    FIREBASE_STORAGE_BUCKET: 'timetracker-manager-dev.appspot.com',
    FIREBASE_MESSAGING_SENDER_ID: '67143581231',
    STRIPE_PUBLIC_KEY: 'pk_test_khrNUE2xAoXWrlpFzTt1gVUz00jgc2FHCa',
    MAX_ACTIVE_PROJECTS_FREE: 1,
    MAX_MEMBERS_FREE: 2,
  },
  prod: {
    FIREBASE_API_KEY: 'AIzaSyD5ma954rxy7hZtsVSaUUZdGMvjJa4BryM',
    FIREBASE_AUTH_DOMAIN: 'timetracker-manager.firebaseapp.com',
    FIREBASE_DATABASE_URL: 'https://timetracker-manager.firebaseio.com',
    FIREBASE_PROJECT_ID: 'timetracker-manager',
    FIREBASE_STORAGE_BUCKET: 'timetracker-manager.appspot.com',
    FIREBASE_MESSAGING_SENDER_ID: '1057791531163',
    STRIPE_PUBLIC_KEY: 'pk_live_aratOjegrFmaRsxlCIu2uoZu00RyBB3Bsd',
    MAX_ACTIVE_PROJECTS_FREE: 3,
    MAX_MEMBERS_FREE: 3,
  },
};

const config = env[process.env.REACT_APP_ENV] || {};

export default {
  ...config,
};



// WEBPACK FOOTER //
// ./src/config.js